import { useQuery } from 'react-query';
import { AnchorAPI } from 'client/modules/AnchorAPI';
import { useCurrentUserCtx } from 'contexts/CurrentUser';

const USE_GEO_REGION_KEY = 'getGeoRegion';

function useGeoRegion() {
  const {
    state: { userId },
  } = useCurrentUserCtx();
  const { data: geoRegionData, status, refetch } = useQuery(
    [USE_GEO_REGION_KEY],
    () => AnchorAPI.getGeoRegion({ userId })
  );

  return {
    geoRegionData,
    status,
    refetch,
  };
}

export { useGeoRegion };
